// extracted by mini-css-extract-plugin
export default {"spinner":"_19xQ","rotator":"_3B8u","path":"_216W","dash":"akU9"};